import queryString from 'query-string'

import { RedirectError } from '@app/packages/routing/RedirectError'
import type { Location } from '@app/packages/routing/types'

import { carryNoApp } from './noApp'

export const assertNoShouldLoginParams = (location: Location) => {
  if (location.pathname !== '/') return
  if (!location.search) return
  const query = queryString.parse(location.search)
  if (query.login === 'true' && typeof query.next === 'string') {
    // `no_app` has to survive the bounce, or the app claims the next hop and the reader loops.
    throw RedirectError.create({ pathname: query.next, search: carryNoApp(location.search, null) })
  }
}
